<template>

    <div class="kanban-main">
        <form>
            <div class="form-group mb-2">
                <!-- <label class="form-label" for="basic-icon-default-fullname" style="font-size: 1rem;">Client Name </label> -->
                <p style="font-weight: 600!important;text-transform: capitalize;font-size: 1.5rem;">{{client_fullname}}</p>
            </div>
            <div class="form-group mb-2">
                <label class="form-label" for="basic-icon-default-fullname" style="font-size: 1.2rem;">Dispute Round Completion Date</label>
                <flat-pickr v-model="due_date" :config="config" placeholder="Due Date" class="form-control" ></flat-pickr>
            </div>
            <div class="form-group mb-2">
                <label class="form-label" for="basic-icon-default-fullname" style="font-size: 1.2rem;">Dispute Round</label>
                <select2 v-model="dispute_round" :options="dispute_rounds" ></select2>
            </div>
            <div class="form-group mb-2">
                <label class="form-label" for="basic-icon-default-fullname" style="font-size: 1.2rem;">Status To</label>
                <select2 v-model="status" :options="pipeline.statuses" ></select2>
            </div>
            <div class="mb-2" v-if="pipeline.client_details.assigned_user != null">
                <label class="form-label" style="font-size: 1.2rem;">Assigned To</label>
                <div class="assigned d-flex flex-wrap">
                    <div class="avatar">
                        <div class="avatar-content avatar-xl bg-light-primary" height="38" width="38" style="color: white !important;background: #4b9a5e !important;">
                            <span class="avatar-content" >
                                {{abbreviateName(pipeline.client_details.assigned_user.full_name)}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-2">
                <label class="form-label" for="attachments" style="font-size: 1.2rem;">Note</label>
                <textarea type="file" class="form-control" rows="3" style="resize: none;" v-model="note"></textarea>
                <button class="btn btn-primary mt-1" v-if="toSaveNote" type="button" v-on:click="saveNote">Save Note</button>
            </div>
            <div class="mb-2">
                <div class="d-flex flex-wrap">
                    <button type="button" class="btn btn-primary me-3 waves-effect waves-light" v-on:click="updateClientAddNote">
                      Update
                    </button>
                    <button type="button" class="btn btn-outline-primary waves-effect ml-1" v-on:click="toggleModel" >
                      Close
                    </button>
                    <button type="button" class="btn btn-outline-info waves-effect ml-1" v-on:click="takeMeToClient(client_id)">
                        View Client
                    </button>
                </div>
            </div>
        </form>
    </div>

</template>
<script>
import {ref} from 'vue';
import flatPickr from 'vue-flatpickr-component';
import Select2 from 'vue3-select2-component'
import {usePipelineStore} from '../../../../../../stores/PipelineStore.js';
import { useLocalizationStore } from '../../../../../../stores/LocalizationStore.js'
import { useUserStore } from '../../../../../../stores/UserStore.js'
import 'vue-select/dist/vue-select.css';
import 'flatpickr/dist/flatpickr.css';
export default{
    name:"edit-pipeline-client",
    display:"edit pipeline client",
    components:{
        flatPickr,
        Select2,
    },
    setup(){
        const client_fullname = ref(),
        due_date = ref(),
        client = ref([]),
        note = ref(),
        dispute_round = ref(),
        status = ref(),
        pipeline = usePipelineStore(),
        userstore = useUserStore(),
        toSaveNote =ref(false),
        dispute_rounds = ref([]);
        return{
            client_fullname,
            pipeline,
            due_date,
            dispute_round,
            dispute_rounds,
            client,
            note,
            status,
            localizationStore: useLocalizationStore(),
            userstore,
            toSaveNote,
            config: {
                wrap : true,
                altFormat : 'F j, Y',
                altInput : true,
                dateFormat : 'Y-m-d',
            },
        }
    },
    watch:{
        async 'client'(value){
            this.client_id = `${value.client.id}`
            this.client_fullname = `${value.client.firstname} ${value.client.lastname}`
            this.dispute_round = `${value.opportunity_id}`
            this.due_date = value.due_date != null?`${value.due_date}`:""
            this.status = value.status != null?`${this.capitalizeAll(value.status)}`:""
        },
        async 'note'(value){
            if(_.isEmpty(this.note)){
                this.toSaveNote = false
            }else{
                this.toSaveNote = true
            }
        }
    },
    mounted(){
        this.getOpportunities();
        this.getClientDetails();
    },
    methods:{
        DateConverter(date){
            let due_date = new Date(date)
            let month = ("0" + (due_date.getMonth() + 1)).slice(-2)
            let day = ("0" + due_date.getDate()).slice(-2);
            return [month, day, due_date.getFullYear()].join("-");
        },
        takeMeToClient(){
            let route,params;
            if(this.userstore.user.isTeamMember){
                params = {
                    client: this.client_id,
                    team:this.userstore.user.teams[0].id
                }
            }else{
                params = {
                    client: this.client_id
                }
            }
            route = this.$router.resolve(
                {
                    name:"report",
                    params:params
                }
            );
            window.open(route.href, "_blank");
        },
        updateClientAddNote(){
            const $this=this;

            if(this.pipeline.client_id == null){
                toastr.error('An error occured while updating', 'Error!');
                return false;
            }
            const route = this.$router.resolve(
                {
                    name:"pipeline.update.client",
                    params:{
                        client: this.pipeline.client_id
                    }
                }
            );
            const params = {
                due_date:this.due_date,
                opportunity_id:this.dispute_round,
                status:this.status.toLowerCase()
            }
            axios.put(route.href,params).then(({data})=>{
                if(data.error != true){
                    toastr.success(data.message, 'Success!');
                    this.pipeline.fetchOpportunities()
                    this.$emit("refresh-client");
                    return true;
                }else{
                    toastr.error('Client Details not fetched', 'Error!');
                    return false;
                }
            }).catch(function(error) {
                toastr.error(error.response.data.response_msg, 'Error!');
                return false;
            });
        },
        saveNote(){
            if(this.pipeline.client_id == null){
                toastr.error('An error occured while updating', 'Error!');
                return false;
            }
            const route = this.$router.resolve(
                {
                    name:"pipeline.update.client",
                    params:{
                        client: this.pipeline.client_id
                    }
                }
            );
            const params = {
                note:this.note,
            }
            if(!_.isEmpty(this.note)){
                axios.put(route.href,params).then(({data})=>{
                    if(data.error != true){
                        toastr.success(data.message, 'Success!');
                        this.pipeline.fetchOpportunities()
                        this.$emit("refresh-client");
                        this.note = ""
                        return true;
                    }else{
                        toastr.error('Client note not updated ', 'Error!');
                        return false;
                    }
                }).catch(function(error) {
                    toastr.error(error.response.data.response_msg, 'Error!');
                    return false;
                });
            }
        },
        getClientDetails(){
            const $this=this;

            if(this.pipeline.client_id == null){
                toastr.error('Client Details not fetched', 'Error!');
                return false;
            }
            const route = this.$router.resolve(
                {
                    name:"pipeline.client.details",
                    params:{
                        client: this.pipeline.client_id
                    }
                }
            );
            axios.get(route.href).then(({data})=>{
                if(data.error != true){
                    $this.client = data.data;
                    return true;
                }else{
                    toastr.error('Client Details not fetched', 'Error!');
                    return false;
                }
            }).catch(function(error) {
                toastr.error(error.response.data.response_msg, 'Error!');
                return false;
            });
        },
        getOpportunities(){
            const $this=this;
            const route = this.$router.resolve(
                {
                    name:"opportunities.show.list",
                }
            );
            axios.get(route.href).then(({data})=>{
                if(data.error != true){
                    $this.dispute_rounds = data.data.map(pipeline => ({
                        id: pipeline.id,
                        text: pipeline.name
                    }));
                    return true;
                }else{
                    toastr.error(data.message, 'Error!');
                    return false;
                }
            }).catch(function(error) {
                toastr.error(error.response.data.response_msg, 'Error!');
                return false;
            });
        },
        capitalizeAll(str){
            let words = str.split(" ");
            for (let i = 0; i < words.length; i++) {
                words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
            }
            return words.join(" ");
        },
        closeModel(){
            this.closePersonalInfoModal.click();
        },
        toggleModel(id){
            this.pipeline.toggleActiveModel = !this.pipeline.toggleActiveModel
        },
        abbreviateName(fullname){
            return fullname.replace(/\b(\w)\w+/g, '$1.').replace(/\s/g, '').replace(/\.$/, '').toUpperCase();
        }
    }
}
</script>
<style>

</style>
